import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import EmptyStateSymbol from './emptyImageMedium';
import { dataHooks } from './constants';
var SecondaryMediaImage = /*#__PURE__*/function (_React$Component) {
  function SecondaryMediaImage() {
    _classCallCheck(this, SecondaryMediaImage);
    return _callSuper(this, SecondaryMediaImage, arguments);
  }
  _inherits(SecondaryMediaImage, _React$Component);
  return _createClass(SecondaryMediaImage, [{
    key: "getClassName",
    value: function getClassName() {
      var _this$props = this.props,
        getClassName = _this$props.getClassName,
        src = _this$props.src,
        children = _this$props.children,
        size = _this$props.size;
      return "".concat(getClassName('control-secondary-media-image'), " ").concat(size === 'small' ? 'small' : '', " ").concat(src || children ? 'has-img' : 'no-img');
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _this$props2 = this.props,
        repeat = _this$props2.repeat,
        src = _this$props2.src;
      var style = {
        backgroundRepeat: repeat ? 'repeat' : 'no-repeat'
      };
      if (src) {
        style.backgroundImage = "url(".concat(src, ")");
      }
      return style;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        automationId = _this$props3.automationId,
        dataHook = _this$props3.dataHook,
        onClick = _this$props3.onClick,
        src = _this$props3.src,
        children = _this$props3.children;
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName(),
        "data-aid": automationId,
        "data-hook": dataHook,
        onClick: onClick,
        style: this.getStyle(),
        tabIndex: 0
      }, !src && !children && /*#__PURE__*/React.createElement(EmptyStateSymbol, {
        key: "emptyStateSymbol"
      }), !src && children && /*#__PURE__*/React.createElement("div", {
        className: "children-container",
        key: "children-container",
        "data-hook": dataHooks.secondaryMediaImageChildrenContainer
      }, children));
    }
  }]);
}(React.Component);
SecondaryMediaImage.displayName = 'SecondaryMediaImage';
SecondaryMediaImage.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Url for the image */
  src: PropTypes.string,
  /** Callback function, triggered on image click */
  onClick: PropTypes.func,
  /** When `true` the image will be displayed as background repeat */
  repeat: PropTypes.bool,
  /** Specifies if image is small or normal size */
  size: PropTypes.oneOf(['small', 'normal'])
};
SecondaryMediaImage.defaultProps = {
  repeat: false,
  size: 'normal'
};
export default compose(SecondaryMediaImage);